import window from 'window-or-global';
import { getConfluence } from '../../facades/globals';
import bookmarkManager from '../resources/bookmark/atlassian-editor-bookmark-manager';

export function linkBrowser() {
	const plugin = () => {
		// The port is quite large, contains templates, css, translations, using wrm to pull in those deps.
		const Confluence = getConfluence();
		// Assumption, the WRM call should populate this Global
		const LinkBrowser = Confluence.Editor.LinkBrowser;

		return {
			init: (ed) => {
				ed.addButton('linkbrowserButton', {
					title: 'confluence.conflink_desc',
					cmd: 'mceConflink',
					class: 'mce_conflink',
				});

				ed.addCommand('mceConflink', () => {
					LinkBrowser.open({
						bookmarkManager,
					});
				});

				ed.addCommand('mceConfAttachments', () => {
					LinkBrowser.open({
						panelKey: LinkBrowser.ATTACHMENTS_PANEL,
						bookmarkManager,
					});
				}); // attachments item in insert menu
			},

			getInfo: () => {
				return {
					longname: 'Confluence Link Browser',
					author: 'Atlassian',
					authorurl: 'http://www.atlassian.com',
					version: `${window.tinymce.majorVersion}.${window.tinymce.minorVersion}`,
				};
			},
		};
	};

	window.tinymce.create('tinymce.plugins.LinkBrowser', plugin());
	window.tinymce.PluginManager.add('linkbrowser', window.tinymce.plugins.LinkBrowser);
}

export function linkBrowserWRM() {
	return ['wr!com.atlassian.confluence.plugins.confluence-link-browser:link-browser-conf-frontend'];
}
